var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.669 6.944l2.038 2.039 4.076-4.077M2.267 6.944l2.038 2.039m4.076-4.077l-1.55 1.565",
    stroke: "#000",
    strokeWidth: 1.081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCheckAll;